import { render, staticRenderFns } from "./multipleSpareParts.vue?vue&type=template&id=0fa8e8cd&scoped=true"
import script from "./multipleSpareParts.vue?vue&type=script&lang=js"
export * from "./multipleSpareParts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fa8e8cd",
  null
  
)

export default component.exports